const imp = () => import(/* webpackChunkName: "loadSprite_sap_surface"*/  "../sprite/loadSprite_sap_surface");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Left-and-right-layout": imp,
  "Icon-Nail-it": imp,
  "Icon-Scale-down": imp,
  "Icon-One-button-Stow": imp,
  "Icon-Refresh": imp,
  "Icon-Ruler": imp,
  "Icon-Process-arrow": imp,
  "Icon-Template": imp,
  "Icon-enlarge-scale": imp,
  "Icon-Screening-conditions": imp,
  "Icon-Up-and-down-layout": imp,
  "Icon-structure": imp,
  "Icon-Default-layout": imp,
  "Icon-grid": imp,
  "Icon-scene": imp,
  "Icon-U8": imp,
  "Icon-variable": imp,
  "Icon-Decreasingvariable": imp,
  "Icon-HTTPexecution": imp,
  "Icon-Assignmentvariable": imp,
  "Icon-Incrementalvariable": imp,
  "Icon-addcomponent": imp,
  "Icon-Applicationvariable": imp,
  "Icon-Clickthebutton": imp,
  "Icon-Fixedvalue": imp,
  "Icon-Systemvariable": imp,
  "Icon-characterstring": imp,
  "Icon-context": imp,
  "Icon-timer": imp,
  "Icon-constant": imp,
  "Icon-Screening-conditions02": imp,
  "Icon-Multipleexecution": imp,
  "Icon-trigger": imp,
}
export default loadMap;